import type { ReactNode } from "react";
import { cx } from "@/utils/cx";
import { Avatar, type AvatarProps } from "../Avatar/Avatar";

const styles = {
	sm: { root: "gap-2", title: "text-sm font-semibold", subtitle: "text-xs" },
	md: { root: "gap-2", title: "text-sm font-semibold", subtitle: "text-sm" },
	lg: { root: "gap-3", title: "text-md font-semibold", subtitle: "text-md" },
	xl: { root: "gap-4", title: "text-lg font-semibold", subtitle: "text-md" },
};

interface AvatarLabelGroupProps extends AvatarProps {
	size: "sm" | "md" | "lg" | "xl";
	title: string | ReactNode;
	subtitle?: string | ReactNode;
	/** Override class for title text color (useful on brand/dark surfaces) */
	titleClassName?: string;
	/** Override class for subtitle text color (useful on brand/dark surfaces) */
	subtitleClassName?: string;
}

export const AvatarLabelGroup = ({
	title,
	subtitle,
	className,
	titleClassName,
	subtitleClassName,
	...props
}: AvatarLabelGroupProps) => {
	return (
		<figure
			className={cx(
				"group flex min-w-0 flex-1 items-center w-full rounded-xl",
				subtitle ? "h-auto" : "h-6",
				styles[props.size].root,
				className,
			)}
		>
			<Avatar {...props} className="shrink-0" />
			<figcaption className="min-w-0 flex-1 text-left">
				<p
					className={cx(
						"w-full text-left text-primary truncate",
						styles[props.size].title,
						titleClassName,
					)}
				>
					{title}
				</p>
				{subtitle && (
					<p
						className={cx(
							"w-full text-left text-tertiary truncate",
							styles[props.size].subtitle,
							subtitleClassName,
						)}
					>
						{subtitle}
					</p>
				)}
			</figcaption>
		</figure>
	);
};
